export const IS_DEV = process.env.NODE_ENV === 'development' ? true : undefined;
